<template>
  <v-btn class="ma-2 white--text" tile :color="btnColor" outlined small style="pointer-events: none;">
    {{ btnText }}
  </v-btn>
</template>

<script>
export default {
  props: {
    btnText: {
      type: String,
      default: "",
    },
    btnColor: {
      type: String,
      default: "error",
    },
  },
};
</script>
